import { createContext, ReactElement, useState } from "react";
import { ModalDialog } from "@/components/dialogs";

interface IModalContext {
  show: (content: ReactElement) => void;
  close: () => void;
  closeRequested: boolean;
}

export const ModalContext = createContext<IModalContext>({} as IModalContext);

export function ModalProvider(props: { children: ReactElement | ReactElement[] }) {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState<ReactElement[]>([]);
  const [closeRequested, setCloseRequested] = useState(false);

  function show(component: ReactElement) {
    setContent((prev) => [...prev, component]);
    setVisible(true);

    // Hide scrollbars.
    document.body.style.overflow = "hidden";
  }

  function close() {
    setCloseRequested(false);

    if (content.length === 1) {
      setContent([]);
      setVisible(false);

      // Restore scrollbars.
      document.body.style.overflow = "unset";
    } else {
      setContent((prev) => [prev[0]]);
    }
  }

  return (
    <ModalContext.Provider value={{ show, close, closeRequested }}>
      <ModalDialog visible={visible} onRequestClose={() => setCloseRequested(true)}>
        {content.map((modal, i) => (
          <div key={i} style={{ display: i === content.length - 1 ? "block" : "none" }}>
            {modal}
          </div>
        ))}
      </ModalDialog>
      {props.children}
    </ModalContext.Provider>
  );
}
